export const DEFAULT_TITLE_MAP = {
  InEstate: 'In-estate Summary',
  OutsideEstate: 'Out-of-estate Assets',
};
